module.exports = __webpack_public_path__ + "media/images/brand/banner/background_800-6324653ec921bd2d6fae4b53773a7879.png";